// Error Messages
export const errorMessages = {
  required: 'es requerido',
  requiredAlt: 'es requerida',
  requiredPlural: 'son requeridos',
  maxLength: 'excede el máximo de caracteres permitidos',
  minLength: 'El valor no cumple con la cantidad mínima de caracteres',
  pattern: "debe tener el formato 'usuario@dominio.com'",
  patternDni: 'debe contener solo números',
  min: 'Valor mínimo',
  max: 'Valor máximo',
  match: 'no coinciden',
  comfirmationRequied: 'Debes confirmar'
};
